<portal-modal modalTitle="Decline Reason" [subtitle]="subtitle" size="md">

	<div class="reason-label">Select one reason</div>

	<div class="reason-options">
		<label class="reason-option" *ngFor="let r of reasons" [class.selected]="selectedReason === r">
			<input type="radio" name="rejectReason" [value]="r" [(ngModel)]="selectedReason">
			<span class="reason-radio"></span>
			<span class="reason-text">{{ r }}</span>
		</label>
	</div>

	<div class="reason-comment" *ngIf="needsComment">
		<div class="reason-label">Leave comment</div>
		<textarea class="form-control" rows="3" [(ngModel)]="comment" placeholder="Tell us a little more…"></textarea>
		<div class="reason-hint">Required when "Other" is selected.</div>
	</div>

	<div class="reason-error portal-error" *ngIf="error">{{ error }}</div>

	<button portal-modal-footer type="button" class="btn btn-outline-secondary" (click)="modal.close()">Cancel</button>
	<button portal-modal-footer type="button" class="btn reason-btn-danger" [disabled]="!canSubmit" [attr.title]="submitBlockedReason" (click)="submit()">{{ saving ? 'Declining' : 'Decline' }}</button>

</portal-modal>
